<script lang="ts">
  import SmallGhostButton from '@/ui/elements/buttons/SmallGhostButton.svelte';

  let { fontSizeIndex = $bindable(), fontSizes, onCopyClick, onExportClick, numWords } = $props();

  function decreaseFontSize() {
    if (fontSizeIndex > 0) {
      fontSizeIndex--;
    }
  }
  function increaseFontSize() {
    if (fontSizeIndex < fontSizes.length - 1) {
      fontSizeIndex++;
    }
  }
</script>

<div class="fr-ns gap-2">
  <SmallGhostButton icon="TextIncrease" label="Text vergrößern" onclick={increaseFontSize}
  ></SmallGhostButton>
  <SmallGhostButton icon="TextDecrease" label="Text verkleinern" onclick={decreaseFontSize}
  ></SmallGhostButton>
  <div class="flex grow items-center justify-center text-c-light">
    {#if numWords}
      <span>{numWords} Wörter</span>
    {/if}
  </div>
  <SmallGhostButton icon="ContentCopy" label="Text kopieren" onclick={onCopyClick}
  ></SmallGhostButton>
  <SmallGhostButton icon="Download" label="Download" onclick={onExportClick}></SmallGhostButton>
</div>
